import {
    ApiOutlined,
    CheckOutlined,
    CloseOutlined,
    DeleteOutlined,
    EditOutlined,
    LoadingOutlined,
    PlayCircleOutlined,
    PoweroffOutlined,
    ReloadOutlined,
} from '@ant-design/icons';
import {
    Dropdown,
    message,
    Modal,
    Table,
} from 'antd';
import { useBackdropClose } from '../hooks/useBackdropClose';
import React, { useCallback, useEffect, useMemo, useState } from 'react';
import CustomPagination from '../components/custom-pagination/CustomPagination';
import { apiService } from '../services/api';
import { formatMskDateTime } from '../utils/moscow-calendar-date';
import { getValidToken } from '../utils/tokenUtils';
import ConnectionCreatePanel from '../components/connection-create-panel/ConnectionCreatePanel';
import { connectionCount, mergeLightConnections, totalModemsLabel } from './connections/lightConnections';
import '../styles/connections.css';

/* ---------- SVG icon components ---------- */
const SyncIcon = () => (
  <svg viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M5.1784 1.46003L4.4704 2.61C4.3975 2.7151 4.2871 2.7883 4.1618 2.8145C4.0366 2.8406 3.9061 2.8178 3.7972 2.7506C3.6883 2.6835 3.6093 2.5772 3.5764 2.4536C3.5435 2.3299 3.5593 2.1984 3.6204 2.086L4.3284 0.93603C4.506 0.65254 4.7526 0.41881 5.0453 0.25679C5.3379 0.09477 5.6669 0.00977 6.0014 0.00977C6.3359 0.00977 6.6649 0.09477 6.9576 0.25679C7.2502 0.41881 7.4969 0.65254 7.6744 0.93603L9.7744 4.353L9.9949 3.1705C10.0192 3.0401 10.0943 2.9247 10.2037 2.8496C10.313 2.7746 10.4478 2.746 10.5782 2.7703C10.7086 2.7945 10.824 2.8696 10.8991 2.979C10.9742 3.0884 11.0027 3.2231 10.9784 3.3535L10.7284 4.6885C10.6645 5.0322 10.4825 5.3427 10.2139 5.5665C9.9453 5.7903 9.607 5.9132 9.2574 5.914C9.1599 5.914 7.6489 5.626 7.6489 5.626C7.521 5.5982 7.4091 5.5214 7.3372 5.412C7.2654 5.3026 7.2393 5.1694 7.2645 5.0409C7.2898 4.9125 7.3644 4.7991 7.4724 4.7251C7.5803 4.651 7.713 4.6223 7.8419 4.645L8.9084 4.8555L6.8214 1.46003C6.7347 1.3203 6.6137 1.205 6.4699 1.12506C6.3262 1.04511 6.1644 1.00316 5.9999 1.00316C5.8354 1.00316 5.6737 1.04511 5.5299 1.12506C5.3862 1.205 5.2652 1.3203 5.1784 1.46003ZM11.7044 7.4895L11.2204 6.7035C11.188 6.6439 11.1437 6.5914 11.0903 6.5494C11.0368 6.5075 10.9754 6.4768 10.9098 6.4593C10.8441 6.4419 10.7756 6.438 10.7084 6.4479C10.6412 6.4578 10.5767 6.4812 10.5189 6.5169C10.461 6.5525 10.4111 6.5996 10.372 6.6552C10.333 6.7108 10.3057 6.7738 10.2918 6.8403C10.2779 6.9068 10.2777 6.9754 10.2912 7.042C10.3048 7.1086 10.3317 7.1717 10.3704 7.2275L10.8544 8.0135C10.9468 8.1614 10.9974 8.3314 11.001 8.5057C11.0046 8.68 10.9611 8.852 10.8749 9.0035C10.7921 9.1547 10.6699 9.2806 10.5213 9.3679C10.3727 9.4552 10.2033 9.5007 10.0309 9.4995H6.3379L6.9734 8.865C7.0646 8.7709 7.1152 8.6446 7.1143 8.5135C7.1133 8.3824 7.0609 8.2569 6.9683 8.1641C6.8758 8.0713 6.7504 8.0185 6.6193 8.0172C6.4882 8.0159 6.3619 8.0661 6.2674 8.157L5.4214 8.9995C5.1574 9.2621 5.0062 9.6172 4.9999 9.9895C4.9999 9.9895 4.9999 9.9945 4.9999 9.9965C4.9999 9.9985 4.9999 10.003 4.9999 10.0065C4.9985 10.1989 5.0356 10.3897 5.109 10.5675C5.1824 10.7453 5.2907 10.9067 5.4274 11.042L6.2684 11.868C6.3148 11.9163 6.3703 11.9548 6.4318 11.9813C6.4933 12.0077 6.5595 12.0215 6.6264 12.0219C6.6934 12.0223 6.7597 12.0092 6.8215 11.9835C6.8833 11.9577 6.9393 11.9198 6.9862 11.8721C7.033 11.8243 7.0698 11.7676 7.0944 11.7053C7.1189 11.643 7.1307 11.5765 7.1291 11.5095C7.1274 11.4426 7.1124 11.3767 7.0848 11.3157C7.0572 11.2548 7.0176 11.1999 6.9684 11.1545L6.3044 10.4995H10.0309C10.3817 10.4983 10.7258 10.4037 11.0279 10.2253C11.3299 10.047 11.579 9.7913 11.7494 9.4848C11.9199 9.1782 12.0055 8.8317 11.9976 8.481C11.9897 8.1304 11.8885 7.7881 11.7044 7.4895ZM3.3899 3.606C3.2261 3.4944 3.0416 3.4166 2.8473 3.3771C2.653 3.3376 2.4529 3.3373 2.2584 3.376L0.94393 3.635C0.87844 3.6466 0.81592 3.6711 0.76002 3.7071C0.70412 3.7431 0.65596 3.7899 0.61836 3.8447C0.58076 3.8995 0.55447 3.9613 0.54104 4.0264C0.52761 4.0916 0.52731 4.1587 0.54014 4.224C0.55298 4.2892 0.5787 4.3512 0.61579 4.4064C0.65289 4.4616 0.70062 4.5088 0.7562 4.5453C0.81177 4.5818 0.87406 4.6069 0.93944 4.619C1.00481 4.6312 1.07195 4.6302 1.13693 4.616L2.1909 4.4085L0.29543 7.4895C0.11135 7.7881 0.01014 8.1303 0.00221 8.4809C-0.00572 8.8316 0.07992 9.178 0.25031 9.4845C0.4207 9.7911 0.6697 10.0467 0.97167 10.2251C1.27364 10.4035 1.6177 10.4982 1.96843 10.4995H3.5399C3.6725 10.4995 3.7997 10.4469 3.8935 10.3531C3.9872 10.2593 4.0399 10.1321 4.0399 9.9995C4.0399 9.8669 3.9872 9.7397 3.8935 9.646C3.7997 9.5522 3.6725 9.4995 3.5399 9.4995H1.96843C1.79642 9.5003 1.62738 9.4547 1.47918 9.3674C1.33097 9.2801 1.2091 9.1544 1.12643 9.0035C1.0403 8.852 0.99673 8.68 1.00034 8.5057C1.00395 8.3314 1.0546 8.1614 1.14693 8.0135L3.0659 4.8945L3.2889 6.0915C3.3133 6.222 3.3885 6.3373 3.498 6.4123C3.6075 6.4873 3.7423 6.5157 3.8727 6.4913C4.0031 6.4669 4.1185 6.3917 4.1934 6.2822C4.2684 6.1727 4.2968 6.038 4.2724 5.9075L4.0224 4.5725C3.9865 4.3775 3.9121 4.1916 3.8035 4.0256C3.6949 3.8597 3.5543 3.717 3.3899 3.606Z" fill="currentColor"/>
  </svg>
);

const RefreshIcon = () => (
  <svg viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clipPath="url(#clip0_km_refresh)">
      <path d="M6.0001 0.999894C6.66336 1.00207 7.31959 1.13576 7.93084 1.39324C8.54208 1.65071 9.09619 2.02685 9.5611 2.49989H8.0001C7.86749 2.49989 7.74032 2.55257 7.64655 2.64634C7.55278 2.74011 7.5001 2.86729 7.5001 2.99989C7.5001 3.1325 7.55278 3.25968 7.64655 3.35345C7.74032 3.44722 7.86749 3.49989 8.0001 3.49989H10.0716C10.3178 3.49976 10.5539 3.4019 10.728 3.2278C10.9021 3.0537 11 2.81761 11.0001 2.57139V0.499894C11.0001 0.367286 10.9474 0.240109 10.8537 0.14634C10.7599 0.0525723 10.6327 -0.000106158 10.5001 -0.000106158C10.3675 -0.000106158 10.2403 0.0525723 10.1465 0.14634C10.0528 0.240109 10.0001 0.367286 10.0001 0.499894V1.53889C9.17369 0.79462 8.15639 0.295099 7.06215 0.0962684C5.96791 -0.102562 4.83991 0.00714982 3.80449 0.413118C2.76907 0.819085 1.86711 1.50528 1.19961 2.39486C0.532105 3.28443 0.125422 4.34227 0.0251013 5.44989C0.0186429 5.51952 0.0267591 5.58973 0.0489327 5.65605C0.0711063 5.72237 0.106851 5.78334 0.153889 5.83509C0.200928 5.88683 0.258228 5.92821 0.32214 5.95658C0.386052 5.98496 0.455174 5.99971 0.525101 5.99989C0.647395 6.00145 0.765868 5.95731 0.857331 5.87612C0.948793 5.79492 1.00666 5.68251 1.0196 5.56089C1.13091 4.31627 1.70359 3.15825 2.62514 2.31431C3.54669 1.47038 4.75051 1.00154 6.0001 0.999894Z" fill="currentColor"/>
      <path d="M11.4756 6.00004C11.3533 5.99848 11.2349 6.04262 11.1434 6.12382C11.0519 6.20501 10.9941 6.31742 10.9811 6.43904C10.8985 7.39066 10.5446 8.2986 9.96145 9.05515C9.37831 9.8117 8.5904 10.3851 7.6912 10.7073C6.79199 11.0296 5.81922 11.0871 4.8883 10.8731C3.95738 10.6591 3.10737 10.1826 2.43912 9.50005H4.00012C4.13273 9.50005 4.25991 9.44737 4.35368 9.3536C4.44744 9.25983 4.50012 9.13266 4.50012 9.00005C4.50012 8.86744 4.44744 8.74026 4.35368 8.64649C4.25991 8.55272 4.13273 8.50005 4.00012 8.50005H1.92862C1.80667 8.49998 1.6859 8.52395 1.57322 8.57059C1.46054 8.61723 1.35816 8.68562 1.27193 8.77185C1.18569 8.85808 1.1173 8.96047 1.07067 9.07315C1.02403 9.18583 1.00006 9.3066 1.00012 9.42855V11.5001C1.00012 11.6327 1.0528 11.7598 1.14657 11.8536C1.24034 11.9474 1.36751 12.0001 1.50012 12.0001C1.63273 12.0001 1.75991 11.9474 1.85368 11.8536C1.94744 11.7598 2.00012 11.6327 2.00012 11.5001V10.4611C2.82654 11.2053 3.84383 11.7048 4.93807 11.9037C6.03232 12.1025 7.16031 11.9928 8.19573 11.5868C9.23115 11.1809 10.1331 10.4947 10.8006 9.60509C11.4681 8.71551 11.8748 7.65767 11.9751 6.55004C11.9816 6.48041 11.9735 6.4102 11.9513 6.34388C11.9291 6.27756 11.8934 6.21659 11.8463 6.16485C11.7993 6.11311 11.742 6.07173 11.6781 6.04335C11.6142 6.01498 11.545 6.00023 11.4751 6.00004H11.4756Z" fill="currentColor"/>
    </g>
    <defs>
      <clipPath id="clip0_km_refresh">
        <rect width="12" height="12" fill="white"/>
      </clipPath>
    </defs>
  </svg>
);

const PlusIcon = () => (
  <svg viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M11.5 5.5H6.5V0.5C6.5 0.367 6.447 0.24 6.354 0.146C6.26 0.053 6.133 0 6 0C5.867 0 5.74 0.053 5.646 0.146C5.553 0.24 5.5 0.367 5.5 0.5V5.5H0.5C0.367 5.5 0.24 5.553 0.146 5.646C0.053 5.74 0 5.867 0 6C0 6.133 0.053 6.26 0.146 6.354C0.24 6.447 0.367 6.5 0.5 6.5H5.5V11.5C5.5 11.633 5.553 11.76 5.646 11.854C5.74 11.947 5.867 12 6 12C6.133 12 6.26 11.947 6.354 11.854C6.447 11.76 6.5 11.633 6.5 11.5V6.5H11.5C11.633 6.5 11.76 6.447 11.854 6.354C11.947 6.26 12 6.133 12 6C12 5.867 11.947 5.74 11.854 5.646C11.76 5.553 11.633 5.5 11.5 5.5Z" fill="currentColor"/>
  </svg>
);

const KrakenMulti = ({ showTitle = true }) => {
  const [connections, setConnections] = useState([]);
  const [loading, setLoading] = useState(false);
  const [syncLoading, setSyncLoading] = useState(false);
  const [bulkActionLoading, setBulkActionLoading] = useState(false);
  const [createPanelVisible, setCreatePanelVisible] = useState(false);
  const [selectedConnectionIds, setSelectedConnectionIds] = useState([]);
  const [bulkRestartModalVisible, setBulkRestartModalVisible] = useState(false);
  // Окно массовой перезагрузки: крестик, Esc и затемнение закрывают, только пока перезагрузка не идёт; затемнение —
  // только настоящим щелчком (владелец 29.10, DF85)
  const handleBulkRestartModalCancel = () => {
    if (!bulkActionLoading) {
      setBulkRestartModalVisible(false);
    }
  };
  const bulkRestartBackdrop = useBackdropClose(handleBulkRestartModalCancel);
  
  // Состояние для мобильной версии
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 768);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);
  const [editingConnection, setEditingConnection] = useState(null);
  const [creatingConnection, setCreatingConnection] = useState(false);
  const [connPage, setConnPage] = useState(1);
  const [connPerPage, setConnPerPage] = useState(50);
  const connPagination = useMemo(() => ({
    current: connPage,
    pageSize: connPerPage,
    showSizeChanger: false,
    className: 'conn-pagination-hidden',
  }), [connPage, connPerPage]);

  const normalizeConnection = useCallback((conn) => ({
    ...conn,
    is_active: Boolean(conn?.is_active),
    status: conn?.is_active ? 'connected' : 'disconnected',
    modem_count:
      conn?.modems_count ??
      conn?.servers_count ??
      conn?.modem_count ??
      0,
    /** Модемы без активной slimiter-прокси (пул для расчёта резерва) — см. GET /api/kraken-connections */
    free_modems: Number(conn?.free_modems) || 0,
    /** Удерживаются резервом: нельзя отдать под новые лимитерные прокси; min(free_modems, reserve_modems_count) */
    reserve_blocked_modem_count: (() => {
      if (conn?.reserve_blocked_modem_count != null && conn?.reserve_blocked_modem_count !== '') {
        const v = Number(conn.reserve_blocked_modem_count);
        return Number.isFinite(v) && v >= 0 ? v : 0;
      }
      const free = Number(conn?.free_modems) || 0;
      const reqRaw = Number(conn?.reserve_modems_count);
      const req = Number.isFinite(reqRaw) && reqRaw >= 0 ? reqRaw : 3;
      return Math.min(free, req);
    })(),
    last_sync: conn?.last_sync || conn?.updated_at || conn?.created_at || null,
    last_restart_at: conn?.last_restart_at || null,
    last_restart_status: conn?.last_restart_status || null,
    last_restart_message: conn?.last_restart_message || null,
    token_expires_at: conn?.token_expires_at || null,
    port_ranges: Array.isArray(conn?.port_ranges) ? conn.port_ranges : [],
    ssh_port: conn?.ssh_port || 22,
    slimiter_unit: conn?.slimiter_unit || 'kbytes',
    has_ssh_host: Boolean(conn?.has_ssh_host === true),
    // list больше не отдаёт host/pubkey — только флаги
    has_ssh_key: Boolean(conn?.has_ssh_key === true),
  }), []);

  const applyConnections = useCallback((nextConnections) => {
    setConnections(nextConnections);
    setSelectedConnectionIds((prev) => {
      const existingIds = new Set(nextConnections.map((conn) => conn.id));
      return prev.filter((id) => existingIds.has(id));
    });
  }, []);

  // Лёгкий ответ без счётчиков: строки берут их из прошлого полного ответа, новые — «…» (DF83).
  const applyLightConnections = useCallback((lightRows) => {
    setConnections((prev) => mergeLightConnections(prev, lightRows));
    setSelectedConnectionIds((prev) => {
      const existingIds = new Set(lightRows.map((conn) => conn.id));
      return prev.filter((id) => existingIds.has(id));
    });
  }, []);

  // Загрузка подключений
  const loadConnections = useCallback(async ({ showLoader = true, lazy = true } = {}) => {
    const token = getValidToken();
    if (!token) {
      setConnections([]);
      setLoading(false);
      return;
    }
    if (showLoader) {
      setLoading(true);
    }

    let hasLightData = false;

    try {
      // Этап 1: быстрая загрузка из БД (light), чтобы сразу отрисовать раздел
      if (lazy) {
        try {
          const lightResponse = await apiService.getActiveKrakenConnections({ light: true });
          const lightConnections = lightResponse?.data?.connections || lightResponse?.data || [];
          if (Array.isArray(lightConnections) && lightConnections.length > 0) {
            applyLightConnections(lightConnections.map(normalizeConnection));
            hasLightData = true;
          }
        } catch (_lightError) {
          // Если light-запрос не удался, продолжаем к полному запросу
        }
      }

      // Этап 2: полный запрос с расширенной статистикой (ленивая догрузка)
      const fullResponse = await apiService.getKrakenConnections();
      const fullConnections = fullResponse?.data?.connections || fullResponse?.data || [];
      const processedConnections = Array.isArray(fullConnections)
        ? fullConnections.map(normalizeConnection)
        : [];

      applyConnections(processedConnections);
    } catch (error) {
      if (!hasLightData) {
        message.error('Ошибка загрузки подключений: ' + error.message);
      }
    } finally {
      if (showLoader) {
        setLoading(false);
      }
    }
  }, [applyConnections, applyLightConnections, normalizeConnection]);


  // Создание/обновление подключения
  const createConnection = async (values) => {
    try {
      setCreatingConnection(true);
      
      if (editingConnection) {
        const updateData = { ...values };
        if (!updateData.password || updateData.password.trim() === '') {
          delete updateData.password;
        }
        if (!updateData.ssh_password || updateData.ssh_password.trim() === '') {
          delete updateData.ssh_password;
        }
        if (!updateData.ssh_private_key_encrypted || updateData.ssh_private_key_encrypted.trim() === '') {
          delete updateData.ssh_private_key_encrypted;
        }
        if (!updateData.ssh_public_key || updateData.ssh_public_key.trim() === '') {
          delete updateData.ssh_public_key;
        }
        
        const updateResp = await apiService.updateKrakenConnection(editingConnection.id, updateData);
        applyConnections(
          connections.map((conn) => (
            conn.id === editingConnection.id
              ? normalizeConnection({ ...conn, ...updateData, slimiter_unit: updateData.slimiter_unit })
              : conn
          ))
        );
        const rewriteCount = updateResp?.data?.slimiter_rewrite_count || 0;
        if (updateResp?.data?.slimiter_rewrite_queued) {
          message.success(`Подключение обновлено. ${rewriteCount} прокси будут переписаны под новую единицу`);
        } else {
          message.success('Подключение обновлено успешно');
        }
      } else {
        await apiService.createKrakenConnection(values);
        message.success('Подключение создано успешно');
      }
      setCreatePanelVisible(false);
      setEditingConnection(null);
      loadConnections();
    } catch (error) {
      message.error((editingConnection ? 'Ошибка обновления подключения: ' : 'Ошибка создания подключения: ') +
        (error.response?.data?.detail || error.message));
    } finally {
      setCreatingConnection(false);
    }
  };

  // Редактирование подключения
  const handleEditConnection = async (connection) => {
    let detail = connection;
    try {
      if (connection?.id) {
        const response = await apiService.getKrakenConnection(connection.id);
        if (response?.data) {
          detail = { ...connection, ...response.data };
        }
      }
    } catch (error) {
      message.warning('Не удалось загрузить SSH-детали подключения');
    }
    setEditingConnection(detail);
    setCreatePanelVisible(true);
  };

  // Удаление подключения
  const deleteConnection = async (id, connectionName) => {
    Modal.confirm({
      title: 'Удалить подключение из Manager?',
      content: `Подключение "${connectionName}" будет удалено только из Manager. Все серверы, модемы и прокси останутся в Kraken и могут быть восстановлены при повторном подключении.`,
      okText: 'Да, удалить',
      cancelText: 'Отмена',
      okButtonProps: { danger: true },
      onOk: async () => {
        try {
          const response = await apiService.deleteKrakenConnection(id);
          
          // Показываем информативное сообщение с деталями удаления
          const deletedConnectionName = response.data.connection_name || connectionName || 'подключение';
          const deletedServers = response.data.deleted_servers || response.data.deleted_stats?.servers || 0;
          const deletedProxies = response.data.deleted_proxies || response.data.deleted_stats?.proxies || 0;
          const serversInKraken = response.data.servers_in_kraken || 0;
          const proxiesInKraken = response.data.active_proxies_in_kraken || 0;
          
          let messageText = `Подключение "${deletedConnectionName}" удалено из Manager. `;
          
          if (deletedServers > 0 || deletedProxies > 0) {
            messageText += `Удалено: ${deletedServers} модемов, ${deletedProxies} прокси. `;
          }
          
          if (serversInKraken > 0 || proxiesInKraken > 0) {
            messageText += `В Kraken остались: ${serversInKraken} серверов, ${proxiesInKraken} активных прокси. `;
          }
          
          messageText += `При повторном подключении данные будут синхронизированы.`;
          
          message.success(messageText);
          
          loadConnections();
        } catch (error) {
          message.error('Ошибка удаления подключения: ' + (error.response?.data?.detail || error.message));
        }
      }
    });
  };

  // Тестирование подключения
  const testConnection = async (id) => {
    try {
      const response = await apiService.testKrakenConnection(id);

      // Проверяем статус тестирования
      if (response.data.status === 'working') {
        message.success(`Подключение работает! Модемов: ${response.data.modem_count || 0}`);
      } else if (response.data.status === 'failed') {
        message.error(`Подключение не работает: ${response.data.error || 'API не отвечает'}`);
      } else {
        // Fallback для старого формата ответа
        if (response.data.message && response.data.message.includes('successful')) {
          message.success(`Подключение работает! ${response.data.message}`);
        } else {
          message.error(`Ошибка подключения: ${response.data.message || 'Неизвестная ошибка'}`);
        }
      }
      loadConnections();
    } catch (error) {
      message.error('Ошибка тестирования: ' + error.message);
    }
  };

  // Включение сервера
  const connectServer = async (id) => {
    try {
      await apiService.connectKrakenConnection(id);
      message.success('Сервер включен успешно');
      loadConnections();
    } catch (error) {
      message.error('Ошибка включения сервера: ' + (error.response?.data?.detail || error.message));
    }
  };

  // Отключение сервера
  const disconnectServer = async (id) => {
    try {
      await apiService.disconnectKrakenConnection(id);
      message.success('Сервер отключен успешно');
      loadConnections();
    } catch (error) {
      message.error('Ошибка отключения сервера: ' + (error.response?.data?.detail || error.message));
    }
  };

  // Перезагрузка Kraken (фоновый режим с polling по документу KRAKEN_RESTART_AND_REBOOT_FLOW.md)
  const handleRestartKraken = async (id) => {
    const connection = connections.find(c => c.id === id);
    const connectionName = connection?.name || `ID ${id}`;

    Modal.confirm({
      title: 'Перезагрузка Kraken',
      content: `Вы уверены, что хотите перезагрузить Kraken на сервере "${connectionName}"?`,
      okText: 'Да',
      cancelText: 'Отмена',
      okButtonProps: { danger: true },
      onOk: async () => {
        try {
          await apiService.restartKraken(id);
          message.info(`Перезагрузка Kraken на "${connectionName}" запущена. Обычно до 2 минут.`);
          loadConnections();

          const pollInterval = setInterval(async () => {
            try {
              const response = await apiService.getKrakenConnections();
              const updatedConnection = (response.data.connections || response.data)?.find(c => c.id === id);

              if (updatedConnection && updatedConnection.last_restart_status !== 'in_progress') {
                clearInterval(pollInterval);
                if (updatedConnection.last_restart_status === 'success') {
                  message.success(`Перезагрузка Kraken на "${connectionName}" успешно завершена!`);
                } else {
                  message.error(`Перезагрузка Kraken на "${connectionName}" завершилась с ошибкой: ${updatedConnection.last_restart_message || 'Неизвестная ошибка'}`);
                }
                loadConnections();
              }
            } catch (pollError) {
              // Игнорируем ошибки polling
            }
          }, 5000);

          setTimeout(() => clearInterval(pollInterval), 300000); // 5 минут
        } catch (error) {
          message.error('Ошибка запуска перезагрузки Kraken: ' + (error.response?.data?.detail || error.message));
        }
      }
    });
  };

  // Перезагрузка сервера
  const handleRebootServer = async (id) => {
    Modal.confirm({
      title: 'Перезагрузка сервера',
      content: 'Вы уверены, что хотите перезагрузить сервер? Это может занять несколько минут.',
      okText: 'Да, перезагрузить',
      cancelText: 'Отмена',
      okButtonProps: { danger: true },
      onOk: async () => {
        try {
          await apiService.rebootKrakenServer(id);
          message.success('Сервер перезагружается...');
          loadConnections();
        } catch (error) {
          message.error('Ошибка перезагрузки сервера: ' + (error.response?.data?.detail || error.message));
        }
      }
    });
  };

  const getSelectedConnections = useCallback(() => {
    if (!Array.isArray(selectedConnectionIds) || selectedConnectionIds.length === 0) {
      return [];
    }
    const selectedIdSet = new Set(selectedConnectionIds);
    return connections.filter((connection) => selectedIdSet.has(connection.id));
  }, [connections, selectedConnectionIds]);

  const handleBulkRestartAction = async (actionType) => {
    const selectedConnections = getSelectedConnections();
    if (selectedConnections.length === 0) {
      message.warning('Выберите хотя бы одно подключение');
      return;
    }

    const eligibleConnections = selectedConnections.filter((connection) => hasSshKey(connection));
    if (eligibleConnections.length === 0) {
      message.warning('У выбранных подключений нет SSH ключей. Массовая перезагрузка недоступна.');
      return;
    }

    setBulkActionLoading(true);
    try {
      const actionRequest = actionType === 'kraken'
        ? apiService.restartKraken
        : apiService.rebootKrakenServer;

      const operationName = actionType === 'kraken'
        ? 'Перезагрузка Kraken'
        : 'Перезагрузка сервера';

      const results = await Promise.allSettled(
        eligibleConnections.map((connection) => actionRequest(connection.id))
      );

      let successCount = 0;
      let errorCount = 0;
      const failedConnectionIds = [];

      results.forEach((result, index) => {
        if (result.status === 'fulfilled') {
          successCount += 1;
          return;
        }
        errorCount += 1;
        failedConnectionIds.push(eligibleConnections[index].id);
      });

      if (successCount > 0 && errorCount === 0) {
        message.success(`${operationName} запущена для ${successCount} подключений`);
      } else if (successCount > 0 && errorCount > 0) {
        message.warning(`${operationName}: успешно ${successCount}, с ошибкой ${errorCount}`);
      } else {
        message.error(`${operationName} не запущена ни для одного подключения`);
      }

      if (errorCount > 0) {
        setSelectedConnectionIds(failedConnectionIds);
      } else {
        setSelectedConnectionIds([]);
      }

      setBulkRestartModalVisible(false);
      await loadConnections();
    } catch (error) {
      message.error('Ошибка массовой перезагрузки: ' + (error?.response?.data?.detail || error?.message || 'Неизвестная ошибка'));
    } finally {
      setBulkActionLoading(false);
    }
  };

  // Синхронизация с Kraken (бэкенд: POST /api/kraken/sync → 202 Accepted, работа в фоне)
  const handleSyncAll = async () => {
    const token = getValidToken();
    if (!token) {
      message.warning('Требуется авторизация для синхронизации');
      return;
    }
    setSyncLoading(true);
    try {
      const response = await apiService.post('/api/kraken/sync');
      const data = response.data || {};
      const isBackground =
        response.status === 202 ||
        data.status === 'accepted';

      if (isBackground) {
        message.info(
          'Синхронизация с Kraken запущена в фоне (модемы и очередь данных). ' +
            'Обычно это занимает от нескольких секунд до нескольких минут. ' +
            'Нажмите «Обновить» позже, чтобы увидеть актуальные счётчики.'
        );
      } else {
        const successful = data.successful_syncs ?? 0;
        const failed = data.failed_syncs ?? 0;
        const total = data.total_modems ?? 0;
        message.success(
          `Синхронизация завершена. Успешно: ${successful}, ошибок: ${failed}, модемов: ${total}`
        );
      }

      await loadConnections();
    } catch (error) {
      message.error(
        'Ошибка синхронизации: ' +
          (error.response?.data?.detail || error.message || 'Неизвестная ошибка')
      );
    } finally {
      setSyncLoading(false);
    }
  };

  useEffect(() => {
    loadConnections({ showLoader: false, lazy: true });
  }, [loadConnections]);

  /* ---------- Quick filter ---------- */
  const [quickFilter, setQuickFilter] = useState(null);

  const handleQuickFilter = useCallback((filter) => {
    setQuickFilter(prev => prev === filter ? null : filter);
  }, []);

  /* ---------- Derived stats ---------- */
  const activeCount = connections.filter(c => c.is_active).length;
  const inactiveCount = connections.length - activeCount;
  const totalModems = totalModemsLabel(connections);

  const filteredConnections = useMemo(() => {
    if (!quickFilter) return connections;
    if (quickFilter === 'active') return connections.filter(c => c.is_active);
    if (quickFilter === 'inactive') return connections.filter(c => !c.is_active);
    return connections;
  }, [connections, quickFilter]);

  /** Check if a connection has SSH configured (host/pubkey в list не приходят) */
  const hasSshKey = (record) => record?.has_ssh_key === true || record?.has_ssh_host === true;

  const formatRestartDate = (raw) => formatMskDateTime(raw);

  const handlePaginationChange = useCallback((paginationInfo) => {
    if (paginationInfo) {
      setConnPage(paginationInfo.current);
      setConnPerPage(paginationInfo.pageSize);
    }
  }, []);

  // Колонки таблицы — Figma layout (desktop / mobile widths)
  const columns = useMemo(() => [
    {
      title: 'Сервер',
      dataIndex: 'name',
      key: 'name',
      width: isMobile ? 112 : 144,
    },
    {
      title: 'Город',
      dataIndex: 'city',
      key: 'city',
      width: isMobile ? 160 : 176,
      render: (value) => (
        <span className="conn-cell--dark">{value || '—'}</span>
      ),
    },
    {
      title: 'Псевдоним',
      key: 'alias',
      width: isMobile ? 192 : 224,
      render: (_, record) => (
        <span className="conn-cell--dark">
          {record.alias || record.server_url || '—'}
        </span>
      ),
    },
    {
      title: 'Диапазон',
      key: 'port_ranges',
      width: isMobile ? 144 : 160,
      render: (_, record) => {
        const portRanges = record.port_ranges || [];
        if (portRanges.length === 0) return '—';
        return portRanges.map(r => `${r.start}-${r.end}`).join(', ');
      },
    },
    {
      title: 'Статус',
      dataIndex: 'is_active',
      key: 'is_active',
      width: isMobile ? 144 : 160,
      render: (isActive) => (
        <span className={`conn-badge conn-badge--${isActive ? 'green' : 'red'}`}>
          {isActive ? 'Активен' : 'Неактивен'}
        </span>
      ),
    },
    {
      title: 'Модемы',
      dataIndex: 'modem_count',
      key: 'modem_count',
      width: isMobile ? 112 : 144,
      render: (count, record) => connectionCount(record, count),
    },
    {
      title: 'Slimiter',
      key: 'slimiter_unit',
      width: isMobile ? 88 : 104,
      render: (_, record) => (
        <span className="conn-cell--dark">
          {record.slimiter_unit === 'bits' ? 'бит' : 'кбайт'}
        </span>
      ),
    },
    {
      title: 'Резерв',
      key: 'reserve_blocked_modem_count',
      dataIndex: 'reserve_blocked_modem_count',
      width: isMobile ? 96 : 112,
      render: (_, record) => {
        const n = connectionCount(record, record.reserve_blocked_modem_count);
        return (
          <span
            className="conn-cell--dark"
            title="Модемы, удерживаемые резервом: не отдаются под новые прокси с лимитерами (min свободных по нагрузке и нормы резерва)"
          >
            {n}
          </span>
        );
      },
    },
    {
      title: 'SSH',
      key: 'ssh_key',
      width: isMobile ? 112 : 144,
      render: (_, record) => {
        if (hasSshKey(record)) {
          return <span className="conn-badge conn-badge--green">Ключ</span>;
        }
        return '—';
      },
    },
    {
      title: 'Последняя перезагрузка',
      key: 'restart',
      render: (_, record) => {
        const lastRestartAt = record.last_restart_at;
        const lastRestartStatus = record.last_restart_status;
        const lastRestartMessage = record.last_restart_message;

        if (!lastRestartAt) return '—';

        const isInProgress = lastRestartStatus === 'in_progress';
        if (isInProgress) {
          return <span className="conn-badge conn-badge--blue"><LoadingOutlined spin style={{ marginRight: 4 }} />Выполняется</span>;
        }

        const isSuccess = lastRestartStatus === 'success';
        return (
          <span className="conn-restart-status" title={lastRestartMessage || ''}>
            <span className={`conn-restart-status__icon conn-restart-status__icon--${isSuccess ? 'success' : 'error'}`}>
              {isSuccess ? <CheckOutlined /> : <CloseOutlined />}
            </span>
            <span className="conn-restart-status__date">{formatRestartDate(lastRestartAt)}</span>
          </span>
        );
      },
    },
    {
      title: 'Токен',
      key: 'token',
      width: isMobile ? 112 : 144,
      render: (_, record) => {
        if (!record.token_expires_at) return '—';
        const isExpired = new Date(record.token_expires_at) < new Date();
        return (
          <span className={`conn-badge conn-badge--${isExpired ? 'red' : 'green'}`}>
            {isExpired ? 'Истек' : 'Активен'}
          </span>
        );
      },
    },
    {
      title: '',
      key: 'actions',
      fixed: 'right',
      width: 40,
      render: (_, record) => {
        const handleMenuClick = ({ key }) => {
          switch (key) {
            case 'edit':
              handleEditConnection(record);
              break;
            case 'connect':
              connectServer(record.id);
              break;
            case 'disconnect':
              disconnectServer(record.id);
              break;
            case 'test':
              testConnection(record.id);
              break;
            case 'restart-kraken':
              handleRestartKraken(record.id);
              break;
            case 'reboot-server':
              handleRebootServer(record.id);
              break;
            case 'delete':
              deleteConnection(record.id, record.name);
              break;
            default:
              break;
          }
        };

        const ssh = hasSshKey(record);

        const menuItems = [
          { key: 'edit', label: 'Редактировать', icon: <EditOutlined /> },
          { type: 'divider' },
          record.is_active
            ? { key: 'disconnect', label: 'Отключить сервер', icon: <PoweroffOutlined /> }
            : { key: 'connect', label: 'Включить сервер', icon: <PlayCircleOutlined /> },
          { key: 'test', label: 'Тестировать подключение', icon: <ApiOutlined /> },
          ssh ? { type: 'divider' } : null,
          ssh ? { key: 'restart-kraken', label: 'Перезагрузка Kraken', icon: <ReloadOutlined />, disabled: syncLoading } : null,
          ssh ? { key: 'reboot-server', label: 'Перезагрузка сервера', icon: <PoweroffOutlined />, disabled: syncLoading, danger: true } : null,
          { type: 'divider' },
          { key: 'delete', label: 'Удалить подключение', icon: <DeleteOutlined />, danger: true }
        ].filter(Boolean);

        return (
          <Dropdown
            menu={{ items: menuItems, onClick: handleMenuClick }}
            trigger={['click']}
            placement="bottomRight"
            overlayClassName="pm-action-dropdown"
          >
            <button
              className="pm-action-dots"
              aria-label="Действия"
              tabIndex={0}
              onClick={(e) => e.stopPropagation()}
            >
              <span className="pm-action-dots__dot" />
              <span className="pm-action-dots__dot" />
              <span className="pm-action-dots__dot" />
            </button>
          </Dropdown>
        );
      }
    },
  // eslint-disable-next-line react-hooks/exhaustive-deps
  ], [syncLoading, connections, isMobile]);

  const rowSelection = useMemo(() => ({
    selectedRowKeys: selectedConnectionIds,
    onChange: (keys) => setSelectedConnectionIds(keys),
    preserveSelectedRowKeys: true,
  }), [selectedConnectionIds]);

  return (
    <div className="pm-content-fade-in">
      {/* Header — Figma */}
      <div className="conn-header">
        {showTitle ? (
          <h1 className="conn-header__title">Подключения</h1>
        ) : null}

        <div className="conn-header__stats">
          <div className="conn-header__stats-group">
            <button type="button" className={`conn-chip conn-chip--outline${!quickFilter ? ' conn-chip--filter-active' : ''}`} onClick={() => setQuickFilter(null)} tabIndex={0}>
              <span className="conn-chip__label">Всего</span>
              <span className="conn-chip__value">{connections.length}</span>
            </button>
            <button type="button" className={`conn-chip conn-chip--outline${quickFilter === 'active' ? ' conn-chip--filter-active' : ''}`} onClick={() => handleQuickFilter('active')} tabIndex={0}>
              <span className="conn-chip__label">Активных</span>
              <span className="conn-chip__value conn-chip__value--green">{activeCount}</span>
            </button>
            <button type="button" className={`conn-chip conn-chip--outline${quickFilter === 'inactive' ? ' conn-chip--filter-active' : ''}`} onClick={() => handleQuickFilter('inactive')} tabIndex={0}>
              <span className="conn-chip__label">Неактивных</span>
              <span className="conn-chip__value conn-chip__value--red">{inactiveCount}</span>
            </button>
          </div>

          <span className="conn-header__separator" />
          <span className="conn-header__stats-label">Модемы</span>

          <div className="conn-header__stats-group">
            <span className="conn-chip conn-chip--outline">
              <span className="conn-chip__label">Всего</span>
              <span className="conn-chip__value">{totalModems}</span>
            </span>
            <span className="conn-chip conn-chip--outline">
              <span className="conn-chip__label">Недоступные</span>
              <span className="conn-chip__value conn-chip__value--red">0</span>
            </span>
          </div>
        </div>

        <div className="conn-header__actions">
          {selectedConnectionIds.length > 0 && (
            <button
              className={`conn-header__action-btn${bulkActionLoading ? ' conn-header__action-btn--loading' : ''}`}
              onClick={() => setBulkRestartModalVisible(true)}
              title={`Перезагрузка (${selectedConnectionIds.length})`}
              aria-label={`Перезагрузка (${selectedConnectionIds.length})`}
              tabIndex={0}
            >
              <PoweroffOutlined />
            </button>
          )}
          <button
            type="button"
            className={`conn-header__action-btn${syncLoading ? ' pm-sync-btn--active' : ''}`}
            onClick={handleSyncAll}
            disabled={syncLoading}
            title="Синхронизировать все"
            aria-label="Синхронизировать все"
            tabIndex={0}
          >
            <SyncIcon />
          </button>
          <button
            className={`conn-header__action-btn${loading ? ' conn-header__action-btn--loading' : ''}`}
            onClick={() => { loadConnections(); }}
            title="Обновить"
            aria-label="Обновить"
            tabIndex={0}
          >
            <RefreshIcon />
          </button>
          <button
            className="conn-header__action-btn conn-header__action-btn--primary"
            onClick={() => {
              setEditingConnection(null);
              setCreatePanelVisible(true);
            }}
            title="Добавить подключение"
            aria-label="Добавить подключение"
            tabIndex={0}
          >
            <PlusIcon />
          </button>
        </div>
      </div>

      {/* Mobile stats (hidden on desktop via CSS) */}
      <div className="conn-stats-mobile">
        <div className="conn-stats-mobile__row">
          <button type="button" className={`conn-chip conn-chip--outline${!quickFilter ? ' conn-chip--filter-active' : ''}`} onClick={() => setQuickFilter(null)} tabIndex={0}>
            <span className="conn-chip__label">Всего</span>
            <span className="conn-chip__value">{connections.length}</span>
          </button>
          <button type="button" className={`conn-chip conn-chip--outline${quickFilter === 'active' ? ' conn-chip--filter-active' : ''}`} onClick={() => handleQuickFilter('active')} tabIndex={0}>
            <span className="conn-chip__label">Активных</span>
            <span className="conn-chip__value conn-chip__value--green">{activeCount}</span>
          </button>
          <button type="button" className={`conn-chip conn-chip--outline${quickFilter === 'inactive' ? ' conn-chip--filter-active' : ''}`} onClick={() => handleQuickFilter('inactive')} tabIndex={0}>
            <span className="conn-chip__label">Неактивных</span>
            <span className="conn-chip__value conn-chip__value--red">{inactiveCount}</span>
          </button>
        </div>
        <div className="conn-stats-mobile__row">
          <span className="conn-header__separator" />
          <span className="conn-header__stats-label">Модемы</span>
          <span className="conn-chip conn-chip--outline">
            <span className="conn-chip__label">Всего</span>
            <span className="conn-chip__value">{totalModems}</span>
          </span>
          <span className="conn-chip conn-chip--outline">
            <span className="conn-chip__label">Недоступные</span>
            <span className="conn-chip__value conn-chip__value--red">0</span>
          </span>
        </div>
      </div>

      {/* Таблица */}
      <div className="conn-table">
        <Table
          columns={columns}
          dataSource={filteredConnections}
          rowSelection={rowSelection}
          rowKey="id"
          loading={loading}
          scroll={{ x: isMobile ? 1288 : 1604 }}
          size="middle"
          pagination={connPagination}
          onChange={handlePaginationChange}
        />
        <CustomPagination
          currentPage={connPage}
          totalPages={Math.max(1, Math.ceil((connections?.length || 0) / connPerPage))}
          totalItems={connections?.length || 0}
          perPage={connPerPage}
          perPageOptions={[5, 10, 20, 50]}
          onPageChange={(p) => setConnPage(p)}
          onPerPageChange={(v) => { setConnPerPage(v); setConnPage(1); }}
        />
      </div>

        {/* Панель создания/редактирования подключения */}
        <ConnectionCreatePanel
          visible={createPanelVisible}
          onClose={() => {
            setCreatePanelVisible(false);
            setEditingConnection(null);
          }}
          onSubmit={createConnection}
          submitting={creatingConnection}
          editingConnection={editingConnection}
        />

        <Modal
          title="Массовая перезагрузка"
          open={bulkRestartModalVisible}
          onCancel={handleBulkRestartModalCancel}
          footer={null}
          maskClosable={false}
          wrapProps={bulkRestartBackdrop}
          closable={!bulkActionLoading}
          destroyOnHidden={false}
        >
          <p style={{ marginBottom: 12 }}>
            Выбрано подключений: <strong>{selectedConnectionIds.length}</strong>
          </p>
          <p style={{ marginBottom: 16 }}>
            Выберите действие для всех отмеченных подключений.
          </p>
          <div style={{ display: 'flex', gap: 8, justifyContent: 'flex-end' }}>
            <button
              className="conn-header__action-btn"
              style={{ width: 'auto', padding: '0 12px' }}
              type="button"
              onClick={() => setBulkRestartModalVisible(false)}
              disabled={bulkActionLoading}
            >
              Отмена
            </button>
            <button
              className={`conn-header__action-btn${bulkActionLoading ? ' conn-header__action-btn--loading' : ''}`}
              style={{ width: 'auto', padding: '0 12px' }}
              type="button"
              onClick={() => handleBulkRestartAction('kraken')}
              disabled={bulkActionLoading}
            >
              Перезагрузка Kraken
            </button>
            <button
              className={`conn-header__action-btn conn-header__action-btn--primary${bulkActionLoading ? ' conn-header__action-btn--loading' : ''}`}
              style={{ width: 'auto', padding: '0 12px' }}
              type="button"
              onClick={() => handleBulkRestartAction('server')}
              disabled={bulkActionLoading}
            >
              Перезагрузка сервера
            </button>
          </div>
        </Modal>

    </div>
  );
};

export default KrakenMulti;
